var _defs, _path, _path2, _polygon, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _rect, _rect2, _circle2, _path14, _path15, _path16, _path17, _rect3, _path18, _path19, _path20, _path21, _rect4, _path22, _rect5, _rect6, _rect7, _rect8, _path23, _path24, _rect9, _rect10, _path25, _rect11, _rect12, _path26, _path27, _path28, _path29, _rect13, _path30, _path31, _rect14, _path32, _path33, _path34, _path35, _path36, _rect15, _circle3, _path37, _rect16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProjectIllustration = (_ref, ref) => {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1208.53 1135.15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-project1{fill:#30252a;}.cls-project2{fill:#4756df;}.cls-project3{fill:#d17142;}.cls-project4{fill:#e68f5b;}.cls-project5{fill:#84401e;}.cls-project6{fill:#ffb7d5;}.cls-project7{fill:#fa3b3c;}.cls-project8{fill:#22c67b;}.cls-project9{fill:#fff;}.cls-project10{fill:#ffbe21;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-project1",
    d: "M391.08,1135.15l-83.2-266.92,0-.1a96.37,96.37,0,0,0-33.45-52.62,96,96,0,0,0-119.73,0,96.39,96.39,0,0,0-33.46,52.62l0,.2L38,1135.15l-5.73-1.78L115.4,866.64a102.34,102.34,0,0,1,35.52-55.81,102,102,0,0,1,127.23,0,102.45,102.45,0,0,1,35.52,55.81l83.14,266.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project2",
    d: "M400.6,788.53H107.24a63.14,63.14,0,0,1-62.49-55L0,384.53l6-.76,44.76,349a57.11,57.11,0,0,0,56.53,49.75H400.6Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-project3",
    points: "540.25 363.6 588.02 517.02 453.14 517.02 440.78 363.6 540.25 363.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project4",
    d: "M549,508s11.67-43.15,54.26-58.57c17.64-6.39,59,0,59,0l43.49,6.08s20.73,2.24,18.64,17.91c-2,15.27-27.46,13.42-27.46,13.42L644.72,508Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project4",
    d: "M631.55,446.7l97.83-9.23s26.16-4.25,28.81,9.15c2.58,13.09-15,17.4-15,17.4l-39,11.85"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project5",
    d: "M650,491.37a51.59,51.59,0,0,1-7.22-.5c-11.5-1.63-20.42-7.18-25.8-16.05l5.13-3.11c10.72,17.67,34.93,13.12,35.18,13.07l1.17,5.89A47,47,0,0,1,650,491.37Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project5",
    d: "M715.27,473.15c-1.6,0-3.32,0-5.11-.14-10.94-.62-18.77-3.21-23.27-7.71a14.47,14.47,0,0,1-4.35-10l-20.66-2.89c-.16,0-11.86-1.81-25.23-2.52l.32-6c13.68.72,25.67,2.56,25.79,2.57l43.45,6.08a36.05,36.05,0,0,1,9.63,2.7c6.92,3.08,10.94,8,11.63,14.09l-2.63,3.32A93.19,93.19,0,0,1,715.27,473.15Zm-26.63-17a8.48,8.48,0,0,0,2.49,4.88c6,6,21.09,6.46,29.51,6-3.4-7.09-15-8.47-15.18-8.49Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project4",
    d: "M438.57,1025.67c-4.22,6.87,6.38,19.87,20.32,32.79,8.4,7.79,18,15.55,26.33,21.93,11.42,8.75,20.39,14.89,20.39,14.89s14.36,9.65,10.76,23.06c-.06.21-.12.43-.19.64-4.7,15.19-23.86,15.28-23.86,15.28H308.49c-.15,0-21.41,0-31.72-22.47a44.35,44.35,0,0,1-3.35-11.34c-6.43-38.69,24.89-100.59,24.89-100.59l28.3-60.28,81.7-174-235.92-1.85s-61.81,1.85-79.33-54.49c-14.67-47.18,16.37-107.76,16.37-107.76l10.26-26.94,360,18.62s106.4,1.47,138.09,43.16c34.23,45,6,88.26,6,88.26l-132.21,215Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project1",
    d: "M470,192.82s38.94,2.8,45.08,36.69C521,262.3,499,273.84,499,273.84L372.27,304l-59.1-68.94Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project4",
    d: "M470.83,145c-1-3.86-2.54-9.21-4.58-15.61,0,0,9.19-12.41,6.41-18.3s-7.72-4.6-15.16-7.37C449.7,82,439.66,56.11,429.62,33.46c-.54-1.23-1.12-2.42-1.75-3.58C409-5.76,358.4-7.94,308.26,15c-52.43,24-39.95,87.18-39.95,87.18l7.55,34.6,6.56,30.06-5.75,16.07L240.5,284.07,343.21,296.2h0l55.25-5.39-14.91-49.2s4.65.49,7,.6c22.25,1,44.69-5.8,60.24-19.44C477.36,199.47,475.41,163.38,470.83,145Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project6",
    d: "M540.8,377.63l-83.18,22.23,8.39,91-10.6,5.66L433.93,508l-83.69,44.72-17.67,9.44L289.93,585H168.51l41.14-185.08-71.23-22.17L79.16,359.28l-31.11-10c4.9-16.36,9.12-31.23,15-42.94,3.75-7.47,8.17-13.65,13.87-18.13,6.12-4.8,15.21-9.7,19.88-15.92,6.67-8.91,8.85-19,15.14-28.22a49.5,49.5,0,0,1,12.47-13.21c5.37-3.79,12.45-7,22.76-9.7,33.25-9.23,79.37,10.91,79.37,10.91L354.65,280.8l76.08-14.28s1-.19,2.68-.48c7.84-1.31,31.26-4.68,48.36-1.26a31.78,31.78,0,0,1,10.08,4l.15.1c7.85,4.78,13.18,12.3,16.29,17.8,1,1.53,2,3,2.85,4.41,4.59,7.25,8.39,15.12,14.14,21.47.19.22.4.44.6.66,6.67,7.07,15.55,11.67,22.71,18.24,10.76,9.88,14.83,21.76,18.58,39.74Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project7",
    d: "M140.1,363.6a59.66,59.66,0,0,1-1.68,14.12L79.16,359.28l-31.11-10c4.9-16.36,9.12-31.23,15-42.94A59.83,59.83,0,0,1,140.1,363.6Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project7",
    d: "M525.28,312.52A59.81,59.81,0,0,1,433.41,266c7.84-1.31,31.26-4.68,48.36-1.26a31.78,31.78,0,0,1,10.08,4l.15.1c7.85,4.78,13.18,12.3,16.29,17.8,1,1.53,2,3,2.85,4.41C515.73,298.3,519.53,306.17,525.28,312.52Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project7",
    d: "M433.93,508l-83.69,44.72-17.67,9.44A59.8,59.8,0,1,1,433.93,508Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-project7",
    cx: 306.03,
    cy: 338.96,
    r: 59.79
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-project5",
    x: 350.28,
    y: 108.42,
    width: 6,
    height: 29.85,
    transform: "translate(12.97 278.94) rotate(-43.82)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-project1",
    x: 409.78,
    y: 80.9,
    width: 21.88,
    height: 6,
    transform: "translate(21.6 241.2) rotate(-32.79)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-project1",
    cx: 431.17,
    cy: 104.82,
    r: 4.06
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project5",
    d: "M344.19,230c-.57-.45-13.87-10.94-19.95-18.34l4.64-3.81c5.66,6.9,18.88,17.32,19,17.43Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project5",
    d: "M445.4,155.6a15.3,15.3,0,0,1-5.23-.91,16.85,16.85,0,0,1-9.21-9l5.59-2.18-2.8,1.09,2.79-1.1a10.85,10.85,0,0,0,5.75,5.59c3.09,1.11,6.91.44,11.35-2l2.86,5.28A23.52,23.52,0,0,1,445.4,155.6Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project1",
    d: "M358.85,174.49s-54.77-16.23-42.32-62.77c9.26-34.6,48-20,48-20s30.56,23.83,63.32-61.8C409-5.76,358.4-7.94,308.26,15c-52.43,24-39.95,87.18-39.95,87.18l2.33,21.18S243,119.48,236,148.59C228,142.93,220.28,140,205.9,140c-28.22,0-51.1,20.06-51.1,44.8a41.13,41.13,0,0,0,10.29,27c-22.74,13.65-37.57,36-37.57,61.27,0,41.58,40.17,75.29,89.72,75.29,30.26,0,57-12.58,73.27-31.84a51.22,51.22,0,0,0,45.79,27.84c28.22,0,51.1-22.42,51.1-50.06A49.6,49.6,0,0,0,368,255s18.24-16.68,15.29-40.12C380,188.5,358.85,174.49,358.85,174.49Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project8",
    d: "M623.72,724.57l-132.21,215H326.61l81.7-174-235.92-1.85s-61.81,1.85-79.33-54.49c-14.67-47.18,16.37-107.76,16.37-107.76l10.26-26.94,360,18.62s106.4,1.47,138.09,43.16C652,681.34,623.72,724.57,623.72,724.57Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-project9",
    x: 389.85,
    y: 732.51,
    width: 67.41,
    height: 6,
    transform: "translate(-423.99 780.73) rotate(-63.12)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project10",
    d: "M516.37,1118.34c-.06.21-.12.43-.19.64-4.7,15.19-23.86,15.28-23.86,15.28H308.49c-.15,0-21.41,0-31.72-22.47a44.35,44.35,0,0,1-3.35-11.34l167.75,12.35,17.72-54.34c8.4,7.79,18,15.55,26.33,21.93h0a22.37,22.37,0,0,0,15.41,36.79Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project1",
    d: "M587,374.41,405.27,342.08s-16.56-4.26-18,3.84c-1.43,7.8,14.78,11.47,14.78,11.47l179.44,46.82,29.19-6.61a3,3,0,0,0,1.1-5.36Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project4",
    d: "M564.16,348.27l-28,24.32-19.7,14.67,14.81,3.86a44.41,44.41,0,0,1-3.4,4.86c-5.9,22.64-21.46,29.95-21.46,29.95L454.7,460.72l-224,136.6s-71.8,56.85-141,20.32c-66.84-35.29-46-120.21-46-120.21L79.16,359.28l130.49,40.61-10.45,47,195-54.19a342.88,342.88,0,0,1,22.21-31.57l43.83,11.44,26.77-16-57.77-10.27,0,0c9.18-9.58,19-17.48,27.74-19.74,18-4.64,42.18,23,42.18,23L537,330s24.13-12.58,32.15-1.59C576.14,337.91,564.16,348.27,564.16,348.27Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project5",
    d: "M464.4,457.81l-3.34-5,43.88-29.52.21-.1c.58-.27,14.4-7.11,19.84-28l.17-.65.43-.51a45.41,45.41,0,0,0,3.14-4.5l5.12,3.13a49.85,49.85,0,0,1-3.23,4.67c-6,22-20.58,30.11-22.68,31.17Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-project5",
    x: 499.21,
    y: 401.67,
    width: 31.32,
    height: 6,
    transform: "translate(-138.03 353.94) rotate(-33.72)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project5",
    d: "M549.83,360.46a15.32,15.32,0,0,1-3.12-13.22c2.86-12.3,20.39-21.18,21.14-21.55l2.68,5.36h0c-4.38,2.2-16.14,9.63-18,17.56a9.46,9.46,0,0,0,2.06,8.22Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-project5",
    x: 499.86,
    y: 388.62,
    width: 17.76,
    height: 6,
    transform: "translate(-126.75 300.3) rotate(-29.41)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-project5",
    x: 486.06,
    y: 350.1,
    width: 14.01,
    height: 6,
    transform: "translate(-110.61 295.06) rotate(-30.12)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-project5",
    x: 172.16,
    y: 448.18,
    width: 27.72,
    height: 6,
    transform: "translate(-130.1 79.38) rotate(-17.97)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-project5",
    x: 417,
    y: 1034.7,
    width: 28.28,
    height: 6,
    transform: "translate(-678.39 859.78) rotate(-58.33)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project4",
    d: "M807,970.52a12.6,12.6,0,0,1-1.39,3.7c-5.94,10.6-18.18,10.65-18.18,10.65L642.83,966.43c-23.89-4.88-37.46-23.88-44.7-39.24a100.26,100.26,0,0,1-7.29-20.94L561.7,825.43,477.92,593.06l-187-9.68L466,490.89s65-47.76,121.39-23.12S657,543.89,657,543.89l44.25,214.5,20.67,100.2c2.45,11.86,15,28.79,29.27,45,7.68,8.67,15.87,17.13,23.28,24.48,14,13.83,25.2,23.73,25.2,23.73S808.91,961.05,807,970.52Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project8",
    d: "M701.2,758.39l-139.5,67L477.92,593.06l-187.06-9.68L466,490.89s65-47.76,121.39-23.12S657,543.89,657,543.89Z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-project9",
    x: 391.04,
    y: 485.25,
    width: 6,
    height: 208.41,
    transform: "translate(-211.81 957.79) rotate(-87.54)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-project9",
    x: 516.81,
    y: 585.74,
    width: 6,
    height: 247.01,
    transform: "translate(-209.75 218.35) rotate(-19.83)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project10",
    d: "M807,970.52a12.6,12.6,0,0,1-1.39,3.7c-5.94,10.6-18.18,10.65-18.18,10.65L642.83,966.43c-23.89-4.88-37.46-23.88-44.7-39.24L727,953.94l24.11-50.39c7.68,8.67,15.87,17.13,23.28,24.48h0a22,22,0,0,0,10.3,37.88Z"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-project9",
    x: 343.52,
    y: 900.55,
    width: 170.14,
    height: 6
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-project9",
    x: 541.56,
    y: 753.56,
    width: 159.79,
    height: 6,
    transform: "translate(-261.55 333.6) rotate(-25.01)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project10",
    d: "M745.09,508,865,299.24a40,40,0,0,1,34.69-20.08H1153.4a25,25,0,0,1,21.68,37.45L1065.14,508"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project10",
    d: "M1081.45,479.64H687.37A57.84,57.84,0,0,0,637.59,508h427.55Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project9",
    d: "M985.59,412.82a19.13,19.13,0,1,1,19.13-19.13A19.16,19.16,0,0,1,985.59,412.82Zm0-33.26a14.13,14.13,0,1,0,14.13,14.13A14.15,14.15,0,0,0,985.59,379.56Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project1",
    d: "M1202.8,1135.15,1052.12,651.76l0-.1A177,177,0,0,0,990.65,555a176.23,176.23,0,0,0-219.91,0,177,177,0,0,0-61.45,96.65l0,.19-150.65,483.3-5.72-1.78,150.61-483.2A183.08,183.08,0,0,1,767,550.32a182.25,182.25,0,0,1,227.41,0,183.08,183.08,0,0,1,63.51,99.85l150.62,483.2Z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-project2",
    x: 637.59,
    y: 505.03,
    width: 540.85,
    height: 6
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project8",
    d: "M925.06,817.72s-64.19-32.57-74-14.82c-6.9,12.48,12.91,21,12.91,21s-58.36,37.37-36.49,60.45c13.68,14.43,59.43-19.48,59.43-19.48s-4.08,18.76,10.16,20C916.11,886.56,925.06,817.72,925.06,817.72Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project1",
    d: "M1008.92,940.55l-25.5-74.94a66.2,66.2,0,0,0-117-16.51l-4.92-3.43a72.2,72.2,0,0,1,127.59,18l25.5,74.94Z"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-project1",
    x: 845.77,
    y: 854.94,
    width: 269.37,
    height: 6,
    transform: "translate(-89.67 1601.04) rotate(-75.96)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project2",
    d: "M833.35,1134.26h285.7s25.21-50.65-1-83c-19.44-24-47.48-25-47.48-25S1087.9,939.09,999,920.75s-109.17,67.86-109.17,67.86-59.2,21.72-69.88,72.7C810.39,1106.87,833.35,1134.26,833.35,1134.26Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project9",
    d: "M891,991.35l-2.43-5.48c1.29-.57,32.19-13.93,79.39-6.08l-1,5.92C921.56,978.15,891.34,991.22,891,991.35Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project9",
    d: "M1044,1036.86l-3.84-4.6c11.85-9.88,29.79-9,30.55-9l-.31,6C1070.21,1029.23,1054,1028.51,1044,1036.86Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project8",
    d: "M1004,716.69s-12.14,41,.6,44.56,23.46-35.73,23.46-35.73"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project7",
    d: "M1002.58,722l-47-82.82,20.91-15.48,22.31,61.24a3,3,0,0,0,5.78-1.48l-10.32-66.29,30.35,6.53L1019,692.75a3,3,0,0,0,5.73,1.44l24-55,18.41,15.18-35.8,55a3,3,0,0,0,3.7,4.4l58.2-25,1.41,33-68,8.51"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-project6",
    x: 905.03,
    y: 624.3,
    width: 6,
    height: 75.68,
    transform: "translate(-213.55 591.49) rotate(-32.5)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-project1",
    cx: 860.95,
    cy: 667.29,
    r: 3.53
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-project10",
    d: "M926.86,747.61C911,730,897.44,715.91,878.54,708.83c-5.85-2.19-13.94-3.93-19.29.2a11.64,11.64,0,0,0-3.74,5.39A44.22,44.22,0,0,1,870,734.11c1.77,4.91-.07,7.38-1.32,8.42-2.68,2.22-6.57,1.46-9.9-1.94-5.36-5.47-8.64-11.19-9.74-17a22.27,22.27,0,0,1-.25-6.55,36.42,36.42,0,0,0-8.21-3.86,38.71,38.71,0,0,0-19.22-1.11,39.72,39.72,0,0,0-17.46,8.18l-3.79-4.66a45.83,45.83,0,0,1,20.1-9.41,44.7,44.7,0,0,1,22.22,1.29,42.13,42.13,0,0,1,8,3.55,17.26,17.26,0,0,1,5.17-6.71c7.53-5.83,17.79-3.8,25.06-1.08,20.18,7.56,34.31,22.13,50.69,40.4ZM854.81,721.7c0,.26.08.51.13.76.87,4.64,3.6,9.32,8.12,13.93a6.35,6.35,0,0,0,1.65,1.24,6,6,0,0,0-.36-1.49A37.73,37.73,0,0,0,854.81,721.7Z"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-project9",
    x: 189.5,
    y: 371.08,
    width: 53.21,
    height: 6,
    transform: "translate(-199.24 492.94) rotate(-75.95)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProjectIllustration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "project-illustration.bd741dd.svg";